<template>
    <div class="el-table-container">
        <el-form size="mini" :inline="true" ref="searchForm" class="query-form" :model="searchForm"
                 @keyup.enter.native="refreshList(1)" @submit.native.prevent>
            <el-form-item prop="name" label="角色名称：">
                <el-input size="small" v-model="searchForm.name" placeholder="请输入角色名称" maxlength="100"
                          clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="refreshList(1)" size="small" icon="el-icon-search">查询</el-button>
                <el-button @click="resetSearch()" size="small" icon="el-icon-refresh-right">重置</el-button>
            </el-form-item>
            <el-form-item class="f_r">
                <el-button v-if="hasPermission('sys:role:add')" type="primary" size="small" icon="el-icon-plus"
                           @click="addEdit('add', '')">新增
                </el-button>
                <el-button v-if="hasPermission('sys:role:del')" type="danger" size="small" icon="el-icon-delete"
                           @click="del()">批量删除
                </el-button>
            </el-form-item>
        </el-form>
        <el-table
                :data="dataList"
                v-loading="loading"
                size="small"
                height="100%"
                @selection-change="selectionChangeHandle"
                class="table" border>
            <el-table-column fixed
                             type="selection"
                             width="50">
            </el-table-column>
            <el-table-column
                    prop="name"
                    label="角色名称">
                <template slot-scope="scope">
                    <el-link type="primary" :underline="false" v-if="hasPermission('sys:role:edit')"
                             @click="addEdit('edit', scope.row.id)">{{scope.row.name}}
                    </el-link>
                    <el-link type="primary" :underline="false" v-else-if="hasPermission('sys:role:view')"
                             @click="addEdit('view', scope.row.id)">{{scope.row.name}}
                    </el-link>
                    <span v-else>{{scope.row.name}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    show-overflow-tooltip
                    prop="remarks"
                    label="备注">
            </el-table-column>
            <el-table-column
                    prop="useable"
                    label="是否可用">
                <template slot-scope="scope">
                    <el-tag size="mini" :type="scope.row.useable == '0' ? 'success' : 'danger'">
                        {{scope.row.useable == '0' ? '是' : '否'}}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column
                    fixed="right"
                    label="操作">
                <template slot-scope="scope">
                    <el-button v-if="hasPermission('sys:role:edit')" type="text" size="mini"
                               @click="addEdit('edit', scope.row.id)">修改
                    </el-button>
                    <el-button v-if="hasPermission('sys:role:del')" type="text" size="mini"
                               @click="del(scope.row)">删除
                    </el-button>
                    <el-button v-if="hasPermission('sys:role:jurisdiction')" type="text"
                               size="mini" @click="showAuth(scope.row)">功能权限
                    </el-button>
                    <el-button v-if="hasPermission('sys:role:assign')" type="text"
                               size="mini" @click="showRight(scope.row)">分配用户
                    </el-button>
                    <el-button type="text" size="mini" @click="roleCopy(scope.row)">角色复制</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 角色复制-->
        <el-dialog title="角色复制" :close-on-click-modal="false" width="50%" :visible.sync="visible">
            <el-form size="small" :model="inputForm">
                <el-form-item label="您正在执行角色复制，请确认复制后的角色名：" prop="name">
                    <el-input size="small" v-model="inputForm.name" placeholder="请输入角色名称" maxlength="100"
                              clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button size="small" @click="visible = false">取消</el-button>
                <el-button v-if="!loading" type="primary" size="small" @click="submit()"
                           v-noMoreClick>保存
                </el-button>
            </div>
        </el-dialog>
        <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                    @pagination="refreshList"/>
        <RoleUserList :role-user-title="roleUserTitle" :role-id="roleId" ref="roleUserList"></RoleUserList>
        <AuthForm ref="authForm"></AuthForm>
        <!-- 弹窗, 新增 / 修改 -->
        <RoleForm ref="roleForm" @refreshDataList="refreshList"></RoleForm>
    </div>
</template>
<script>
    import RoleForm from './RoleForm'
    import AuthForm from './AuthForm'
    import RoleUserList from './RoleUserList'

    export default {
        data() {
            return {
                searchForm: {
                    name: '',
                    current: 1,
                    size: 20,
                },
                dataList: [],
                total: 0,
                dataListSelections: [],
                roleUserTitle: '',
                roleId: '',
                loading: false,
                visible: false,
                inputForm: {
                    name: '',
                }
            }
        },
        components: {
            RoleForm,
            AuthForm,
            RoleUserList,
        },
        activated() {
            this.refreshList(1)
        },
        methods: {
            // 获取数据列表
            refreshList(type) {
                if (type == 1) {
                    this.searchForm.current = 1
                }
                this.loading = true
                this.$axios(this.api.user.sysroleList, this.searchForm, 'get').then(data => {
                    if (data.status) {
                        this.dataList = data.data.records
                        if (this.dataList.length == 0 && this.searchForm.current > 1) {
                            this.searchForm.current--
                            this.refreshList()
                        }
                        this.total = parseInt(data.data.total)
                        this.loading = false
                    }
                })
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val
            },

            // 排序
            sortChangeHandle(obj) {
                if (obj.order === 'ascending') {
                    this.orderBy = obj.prop + ' asc'
                } else if (obj.order === 'descending') {
                    this.orderBy = obj.prop + ' desc'
                } else {
                    this.orderBy = ''
                }
                this.refreshList()
            },
            // 新增，修改，查看
            addEdit(method, id) {
                this.$refs.roleForm.init(method, id)
            },
            // 删除
            del(row) {
                let deleteList = row ? [row] : this.dataListSelections
                if (!deleteList.length) {
                    this.$message.warning('请至少选择一条数据')
                    return
                }
                let enableList = []
                let ids = deleteList.map(item => {
                    if (item.useable == 0){
                        enableList.push(item)
                    }
                    return item.id
                }).join(',')
                if (enableList.length) {
                    this.$message.warning('请先禁用后再删除！')
                    return
                }
                this.$confirm(`确定删除所选项吗?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.loading = true
                    this.$axios(this.api.user.sysroleRemoveById, {'ids': ids}, 'delete').then(data => {
                        this.loading = false
                        if (data.status) {
                            this.$message.success('删除成功')
                            this.refreshList()
                        } else {
                            this.$message.error(data.msg)
                        }
                    })
                })
            },
            // 重置
            resetSearch() {
                this.$refs.searchForm.resetFields()
                this.refreshList(1)
            },
            // 分配用户
            showRight(row) {
                this.roleId = row.id
                this.roleUserTitle = row.name
                this.$nextTick(() => {
                    this.$refs.roleUserList.init()
                })
            },
            // 角色授权
            showAuth(row) {
                this.roleId = row.id
                this.$nextTick(() => {
                    this.$refs.authForm.init(row.id)
                    this.roleUserTitle = row.name
                })
            },
        }
    }
</script>
